import React from 'react'
import PropTypes from 'prop-types'

const Count = ({ count, singular, plural, iconClassName, ...restProps }) => (
  <div {...restProps}>
    {iconClassName && <i className={iconClassName} />}
    &nbsp;
    {count}
    &nbsp;
    {count === 1 ? singular : plural}
  </div>
)

Count.propTypes = {
  count: PropTypes.number.isRequired,
  singular: PropTypes.string.isRequired,
  plural: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
}

export default Count



// WEBPACK FOOTER //
// ./src/components/common/Count.jsx